import { words } from 'lodash';
import { localizeDateTime, DateFormat, TimeFormat } from 'utils/l10n';
import { ExitRuleExitsByNode } from 'modules/workflowIndex/types';
import { IS_NOT_SET, IS_SET } from 'utils/comparatorTypes';
import { Node } from 'modules/workflows/types';
import {
  TileOptionContainer,
  TileExitCount,
  TileExit,
  TileId,
  TileTitle,
  TileExitContainer,
} from './ExitRuleSlideOver.styled';

export const getFormattedCreatedAt = (dateStr: string = '') => {
  const date = new Date(dateStr);
  return localizeDateTime(date, {
    dateStyle: DateFormat.Numeric,
    timeStyle: TimeFormat.TwelveHour,
    showTime: true,
  });
};

export const normalizeComparatorType = (comparatorType: string) =>
  words(comparatorType)
    .map((c: string) => c.toLocaleLowerCase())
    .join(' ');

export const aggregateExitRuleCountsForJourney = (exitRuleExitsByNode: ExitRuleExitsByNode) =>
  Object.values(exitRuleExitsByNode).reduce(
    (acc: Record<string, number>, value: Record<string, number>) => {
      Object.entries(value || {})?.forEach(([key, value1]) => {
        acc[key] = acc[key] ? acc[key] + value1 : value1;
      });
      return acc;
    },
    {},
  );

export const getExitRuleCountsForNodeId = (
  exitRuleExitsByNode: ExitRuleExitsByNode,
  nodeId: string,
) => exitRuleExitsByNode?.[nodeId];

export const getTotalCount = (exitRuleExitsByNode: Record<string, number>) =>
  Object.values(exitRuleExitsByNode || [])?.reduce((acc: number, value: number) => acc + value, 0);

export const isSetOrNotSetComparatorType = (comparatorType: string) =>
  [IS_NOT_SET, IS_SET].includes(comparatorType);

export const ALL_KEY = 'all';

export const getSelectedValue = (selectedNodeId: string, nodes: Node[]) => {
  const selectedNode = nodes?.find((node: Node) => node.id === selectedNodeId);
  if (selectedNodeId) {
    return {
      label: selectedNode?.title,
      value: selectedNodeId,
    };
  }
  return {
    label: 'All tiles',
    value: ALL_KEY,
  };
};

export const getOptions = (
  nodeIds: string[],
  nodes: Node[],
  exitRuleExitsByNode: ExitRuleExitsByNode,
  totalExitCount: number,
) => {
  const nodeIdCount = nodeIds
    ?.map((nodeId: string) => {
      const nodeTotals = getExitRuleCountsForNodeId(exitRuleExitsByNode, nodeId);
      const count = getTotalCount(nodeTotals) as number;
      return {
        id: nodeId,
        count,
      };
    })
    .sort((a, b) => b.count - a.count);
  const options = nodeIdCount.map((item: { id: string; count: number }) => {
    const foundNode = nodes?.find((node: Node) => node.id === item.id);
    return {
      label: (
        <TileOptionContainer>
          <TileTitle>{foundNode?.title}</TileTitle>
          <TileId>ID: {foundNode?.id}</TileId>
        </TileOptionContainer>
      ),
      value: item.id,
      Suffix: (
        <TileExitContainer>
          <TileExit>Exited:</TileExit>
          <TileExitCount>{item.count}</TileExitCount>
        </TileExitContainer>
      ),
    };
  });
  const allOption = {
    label: <TileTitle>All tiles</TileTitle>,
    value: 'all',
    Suffix: (
      <TileExitContainer>
        <TileExit>Exited:</TileExit>
        <TileExitCount>{totalExitCount}</TileExitCount>
      </TileExitContainer>
    ),
  };

  const allOptions = [allOption, ...options];
  return allOptions;
};
